/** Flat delivery fee charged on every order. */
export const SHIPPING_FEE = 99;

/** Kept for older copy references; free-shipping threshold is disabled. */
export const FREE_SHIPPING_MIN = null;

export function calcShipping(subtotal) {
  const amount = Number(subtotal) || 0;
  if (amount <= 0) return 0;
  return SHIPPING_FEE;
}

export const freeShippingLabel = `Flat shipping ₹${SHIPPING_FEE} on every order`;
